
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Login from '../views/auth/Login';

import PrivateRoute from './privateRoute';
import PublicRoute from './publicRoute';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import { useDispatch } from 'react-redux'
import { refreshToken } from '../store/slices/auth';
import RecoverPassword from '../views/auth/RecoverPassword';
import { AccountingEntriesGrid } from '../views/accounting/entries/AccountingEntriesGrid';
import { AccountingEntriesGridMaterial } from '../views/AccountingEntriesGridMaterial';
import { SyncJournal } from '../views/accounting/config/SyncJournal';

function MyRoutes() {

  const dispatch = useDispatch<AppDispatch>();
  const authState = useSelector((state: RootState) => state.auth);
  // const { showAlert, handleShowAlert, handleCloseAlert, currentNotificationCount } = useServiceAlert();

  useEffect(() => {
    if (authState.companyselected) {
      dispatch(refreshToken(authState.companyselected.Token));
    }
		// eslint-disable-next-line
  }, [authState.companyselected]);


  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     handleShowAlert();
  //   }, 500);

  //   return () => clearTimeout(timer);
  // }, [handleShowAlert]);

  return (
    <BrowserRouter>
      {/* <ServiceAlertModal
        open={showAlert}
        onClose={handleCloseAlert}
        currentNotificationCount={currentNotificationCount}
      /> */}
        {/* <ScrollToTop /> */}
      <Routes>
        <Route path="/ingresar" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/recuperar-contrasena" element={<PublicRoute><RecoverPassword /></PublicRoute>} />
        <Route 
          path="/contabilidad/libro-diario" 
          element={
            <PrivateRoute hiddenHeader={true}>
              <AccountingEntriesGrid />
            </PrivateRoute>
          }
        />
        <Route 
          path="/contabilidad/sincronizar-libro-diario" 
          element={
            <PrivateRoute hiddenHeader={true}>
              <SyncJournal />
            </PrivateRoute>
          }
        />
        <Route 
          path="/asientos-material" 
          element={
            <PrivateRoute 
              hiddenHeader={true}
            >
              <AccountingEntriesGridMaterial />
            </PrivateRoute>
          }
        />
        
        

        <Route path="*" element={<PrivateRoute><label>Not found</label></PrivateRoute>} />
      
      </Routes>
    </BrowserRouter>
  );
}

export default MyRoutes;
